export default __webpack_public_path__ + "static/media/SMART.ae4b942b.png";